const draggable = {
    /**
     * @param source 拖拽目标
     * @param trigger 触发目标
     */
    inserted(el, binding, vnode, prevVnode) {
        const source = binding.value && binding.value.source ? document.querySelector(binding.value.source) : el;
        const trigger = binding.value && binding.value.trigger ? document.querySelector(binding.value.trigger) : el;
        console.log(source, trigger);
        if (!source && !trigger) {
            return console.warn('未获取到移动元素！');
        }
        trigger.style.cursor = 'move'
        // let pageX = 0
        // let pageY = 0
        // let ol = 0
        // let ot = 0
        let canMove = false
        document.onselectstart = () => {
            return
        }
        trigger.onmousedown = (e) => {
            console.log(e.target);
            
            if (e.target !== trigger) return
            canMove = true
            let ol = source.offsetLeft
            let ot = source.offsetTop
            source.style.margin = '0px'
            source.style.left = ol + 'px'
            source.style.top = ot + 'px'
            source.style.position = 'absolute'
            const disX = e.clientX - ol; // 父级定位元素相对于浏览器视口的X轴距离
            const disY = e.clientY - ot; // 父级定位元素相对于浏览器视口的Y轴距离
            console.log( e.clientX - disX);
            
            document.onmousemove = (e) => {
                if (canMove) {
                    source.style.left = e.clientX - disX + 'px';
                    source.style.top = e.clientY - disY + 'px';
                }
                return false;
            }
            document.onmouseup = (e) => {
                canMove = false
                document.onmousemove = null
                document.onmouseup = null
                document.onselectstart = null
            }
            return false;
        }
    }

}

export default draggable


// WEBPACK FOOTER //
// ./src/common/directives/draggable/index.js